import { createEntityStore, type EntityState } from '@datorama/akita';
import { type TaxonomyCriterion } from 'types/models';

export interface MinimumSafeguardsState extends EntityState<TaxonomyCriterion> {
   status: undefined;
}

const store = createEntityStore<MinimumSafeguardsState>({ status: undefined }, { resettable: true, name: 'taxonomy/minimumsafeguards' });

export default store;
